<template>
  <v-dialog width="400px" persistent v-if="success" :value="hasSuccess">
    <v-card>
      <v-card-title class="ml-2" primary-title v-if="success.title">
        <div>
          <div class="success--text headline">{{ success.title }}</div>
        </div>
      </v-card-title>
      <v-card-text
        class="primary--text headline font-weight-medium text-xs-center"
      >
        <span>{{ success.message }}</span>
      </v-card-text>
      <v-card-actions>
        <v-btn block flat color="secondary" @click="fecharDialogSuccess"
          >OK</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    fecharDialogSuccess () {
      this.$store.dispatch('setSuccess', null)
    }
  },
  computed: {
    success () {
      return this.$store.getters.success
    },
    hasSuccess () {
      return !!this.$store.getters.success
    }
  }
}
</script>
